import React, { useState } from 'react'
import { AgendarStore } from '../AgendarStore'
import { format } from 'date-fns'
import styled from '@emotion/styled'
import { useReactToPrint } from 'react-to-print'
import { useRef } from 'react'
import { ReactComponent as AgendamentoRealizadoSVG } from '../../../../assets/icons/agendado.svg'
import { ReactComponent as CopyIcon } from '../../../../assets/icons/copy3.svg'
import { ReactComponent as LinkCurso } from '../../../../assets/icons/link-curso.svg'
import { Show } from '../../../../components/common/Show'
import { calculaDataFimTurma } from '../turmas/TurmasDisponiveis'
import { getCobrancaUrl } from '../../../../components/common/getCobrancaUrl'

const AgendamentoCriado = () => {
  const {
    Container,
    Layout,
    ContainerInfo,
    NovoAgendamento,
    ButtonContainer,
    CursoButton,
    FlexContent,
    TitleComprovante,
    TitleInfo,
    DataInfo,
    CardComprovante,
    Title,
    SideInfo,
    PrintButton,
    FaixaAmarela,
    Divisor,
    Icon,
    Separator,
    InfoContainer,
  } = AgendamentoCriado
  const { agendamento, paramsPilotar } = AgendarStore.useState()
  const dispatch = AgendarStore.useDispatch()
  const [copyLink, setCopyLink] = useState(false)
  const reportRef = useRef() as any

  const handlePrint = useReactToPrint({ content: () => reportRef?.current })

  function handleClickNovoAgendamento() {
    dispatch(AgendarStore.actions.clear())
    location.reload()
  }

  const handleCopyLink = () => {
    if (!agendamento?.identificadorCobranca) return
    setCopyLink(true)
    const cobrancaUrl = getCobrancaUrl(+agendamento.identificadorCobranca)
    navigator.clipboard.writeText(cobrancaUrl)
    setTimeout(() => {
      setCopyLink(false)
    }, 2000)
  }

  if (!agendamento?.turma) return null

  const dataFim = new Date(
    calculaDataFimTurma({
      dataInicio: agendamento?.turma.dataInicio,
      modalidade: agendamento.turma.modalidade,
      tipoCurso: agendamento.turma.tipoCurso,
    })
  )

  function formatDate(data: string) {
    if (!data) return ''
    return format(new Date(data), 'dd/MM/yyyy')
  }

  return (
    <Container>
      <Layout>
        <FlexContent>
          <AgendamentoRealizadoSVG className="agendamento-realizado-svg" />
          <ContainerInfo>
            <h1>Agendamento realizado com sucesso!</h1>
            <p>Parabéns! Presença confirmada, fique atento e compareça na data selecionada.</p>
            <p>Abaixo segue seu comprovante de agendamento.</p>

            <ButtonContainer>
              <Show condition={!agendamento.readOnly}>
                <CursoButton
                  className="book"
                  href="https://go.superau.la/login"
                  target="_blank"
                  rel="noreferrer"
                >
                  Link do Curso
                  <LinkCurso />
                </CursoButton>
              </Show>
              <Show condition={!!paramsPilotar && !agendamento.readOnly}>
                <NovoAgendamento disabled={agendamento.readOnly} onClick={handleCopyLink}>
                  {copyLink ? 'Link copiado!' : 'Copiar link'} <CopyIcon />
                </NovoAgendamento>
              </Show>
              <Show condition={!paramsPilotar}>
                <NovoAgendamento onClick={handleClickNovoAgendamento}>
                  Novo Agendamento
                </NovoAgendamento>
              </Show>
            </ButtonContainer>
          </ContainerInfo>
        </FlexContent>

        <TitleComprovante>Comprovante de agendamento</TitleComprovante>

        <CardComprovante ref={reportRef}>
          <FaixaAmarela />
          <InfoContainer>
            <SideInfo>
              <Title>Turma {agendamento.turma.modalidade}</Title>
              <TitleInfo>
                CFC de origem: <DataInfo>{agendamento.cfcOrigem?.fantasia}</DataInfo>{' '}
              </TitleInfo>
              <TitleInfo>
                CFC de destino: <DataInfo>{agendamento.cfcDestino?.fantasia}</DataInfo>
              </TitleInfo>
              <TitleInfo>
                Data:{' '}
                <DataInfo>
                  {formatDate(agendamento.turma.dataInicio)} à {formatDate(dataFim.toISOString())}{' '}
                </DataInfo>
              </TitleInfo>
              <TitleInfo>
                Tipo de curso:{' '}
                <DataInfo>
                  {agendamento.tipoCurso === 'PRIMEIRA_VIA' ? 'Primeira via' : 'Renovação'}{' '}
                </DataInfo>
              </TitleInfo>
              <TitleInfo>
                Tipo de agendamento: <DataInfo>{agendamento.tipoAgendamento}</DataInfo>{' '}
              </TitleInfo>
            </SideInfo>
            <Separator />
            <SideInfo>
              <Title>Aluno</Title>
              <TitleInfo>
                Nome: <DataInfo>{agendamento.nome}</DataInfo>
              </TitleInfo>
              <TitleInfo>
                CPF: <DataInfo>{agendamento.cpf}</DataInfo>
              </TitleInfo>
              <TitleInfo>
                Renach: &nbsp; <DataInfo>{agendamento.renach} </DataInfo>
              </TitleInfo>
              <TitleInfo>
                Data Renach: <DataInfo>{formatDate(agendamento.dataRenach)} </DataInfo>
              </TitleInfo>
              <TitleInfo>
                Telefone: <DataInfo>{agendamento.telefone} </DataInfo>
              </TitleInfo>
              <Show condition={agendamento.tipoAgendamento === 'REPOSICAO'}>
                <TitleInfo>
                  Quantidade de Turnos: <DataInfo>{agendamento?.qtdTurnos} </DataInfo>
                </TitleInfo>
              </Show>
              <PrintButton onClick={handlePrint}>Imprimir comprovante</PrintButton>
            </SideInfo>
          </InfoContainer>
        </CardComprovante>
      </Layout>
    </Container>
  )
}
AgendamentoCriado.Container = styled.div`
  display: flex;
  justify-content: center;
`
AgendamentoCriado.Layout = styled.div`
  display: flex;
  flex-direction: column;
`
AgendamentoCriado.TitleComprovante = styled.strong`
  color: #3a3a3a;
  font-size: 15px;
  font-weight: 600;
  text-align: center;
`
AgendamentoCriado.TitleInfo = styled.p`
  color: #898989;
  font-size: 15px;
  font-weight: 400;
  margin: 0;
`
AgendamentoCriado.DataInfo = styled.strong`
  color: #3a3a3a;
  font-size: 14px;
  font-weight: 600;
  margin: 50px 0;
`

AgendamentoCriado.CardComprovante = styled.div`
  display: flex;
  background: #ffffff;
  border: 1px solid #fbba3e;
  border-radius: 8px;
  margin-top: 13px;
  max-width: 700px;
  padding: 20px;
  position: relative;
`
AgendamentoCriado.FaixaAmarela = styled.div`
  display: flex;
  background: #fbba3e;
  border: 1px solid #fbba3e;
  border-radius: 7px 0px 0px 7px;
  width: 34px;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
`
AgendamentoCriado.InfoContainer = styled.div`
  display: flex;
  gap: 10px;
  margin-left: 20px;
  @media (max-width: 756px) {
    flex-direction: column;
  }
`
AgendamentoCriado.Divisor = styled.hr`
  border-top: 1px solid #ccc;
  margin: 0 0 30px 0;
`

AgendamentoCriado.Title = styled.h2`
  color: #fbba3e;
  font-size: 14px;
  font-weight: 600;
`

AgendamentoCriado.TextBold = styled.h2`
  color: #898989;
  font-size: 14px;
  font-weight: 600;
  margin: 0;
`

AgendamentoCriado.TextSemiBold = styled.h3`
  color: #898989;
  font-size: 14px;
  font-weight: 600;
`

AgendamentoCriado.TextLight = styled.span`
  display: flex;
  color: #898989;
  font-size: 14px;
  font-weight: 400;
`

AgendamentoCriado.TextSmall = styled.span`
  color: #898989;
  font-size: 12px;
  font-weight: 400;
`

AgendamentoCriado.FlexContent = styled.div`
  display: flex;
  margin-bottom: 25px;
  flex-direction: column;
  align-items: center;
  gap: 15px;
  @media (max-width: 756px) {
    flex-direction: column;
    align-items: center;
  }
  .agendamento-realizado-svg {
    height: 77px;
    width: 167px;
  }
`

AgendamentoCriado.ContainerInfo = styled.div`
  display: block;
  max-width: 700px;
  text-align: center;
  h1 {
    color: #3a3a3a;
    font-size: 25px;
    font-weight: 600;
    margin: 0;
  }

  h2 {
    color: #3a3a3a;
    font-size: 16px;
    font-weight: 700;
    margin: 20px 0;
  }

  p {
    color: #343a40;
    font-size: 15px;
    margin: 0;
  }
`
AgendamentoCriado.Icon = styled.img`
  width: 15px;
  height: 15px;
  filter: invert(50%);
`
AgendamentoCriado.NovoAgendamento = styled.button`
  display: flex;
  height: 36px;
  border-radius: 8px;
  align-items: center;
  font-size: 16px;
  border: 1px solid #c2c2c2;
  place-content: center;
  background: transparent;
  cursor: pointer;
  transition: 0.19s;
  gap: 7px;
  padding: 0 20px;
  color: #898989;
  &:hover {
    filter: brightness(0.9);
  }
`
AgendamentoCriado.PrintButton = styled.button`
  display: flex;
  justify-content: space-evenly;
  height: 36px;
  border-radius: 8px;
  align-items: center;
  font-size: 16px;

  background: #fbba3e;
  border: 1px solid #fbba3e;
  color: #ffffff;
  margin-top: 20px;
  cursor: pointer;
  transition: 0.19s;
  padding: 0 20px;

  &:hover {
    filter: brightness(0.9);
  }
`

AgendamentoCriado.CursoButton = styled.a`
  display: flex;
  height: 36px;
  border-radius: 8px;
  align-items: center;
  font-size: 16px;
  padding: 0 20px;
  gap: 7px;
  justify-content: center;
  border: 1px solid #fbba3e !important;
  background: #fbba3e !important;
  color: #ffffff !important;
  text-decoration: none;
  cursor: pointer;
  transition: 0.19s;

  &:hover {
    filter: brightness(0.9);
  }
`
AgendamentoCriado.ButtonContainer = styled.div`
  display: flex;
  gap: 7px;
  justify-content: center;
  margin-top: 15px;
  @media (max-width: 756px) {
    flex-direction: column;
    button {
      width: 100%;
    }
  }
`
AgendamentoCriado.SideInfo = styled.div`
  display: block;
  margin-top: 20px;
  margin-left: 20px;
`
AgendamentoCriado.Separator = styled.div`
  border: 1px solid #eaeae9;
  height: 100%;
  @media (max-width: 756px) {
    display: none;
  }
`

export default AgendamentoCriado
